export default function AdHocSearchController(SearchConfig, ZebraService) {
    var ctrl = this;

    ctrl.$onChanges = function(changes) {
        if (changes) {
            if (changes.catalogid) {
                ctrl.catalogid = changes.catalogid.currentValue;
            }
            if (changes.schemasList) {
                ctrl.schemasList = changes.schemasList.currentValue;
            }
            if (changes.facetsList) {
                ctrl.facetsList = changes.facetsList.currentValue;
            }
            if (changes.rsnList) {
                ctrl.rsnList = changes.rsnList.currentValue;
            }
            if (changes.sortKeysList) {
                ctrl.sortKeysList = changes.sortKeysList.currentValue;
            }
            if (changes.hitsList) {
                ctrl.hitsList = changes.hitsList.currentValue;
            }
        }
    };

    ctrl.$onInit = function() {
        var docid_enc;

        if (!ctrl.catalogid) {
            ctrl.catalogid = SearchConfig.catalogid;
        }
        if (!ctrl.schemasList) {
            ctrl.schemasList = SearchConfig.schemasList;
        }
        if (!ctrl.facetsList) {
            ctrl.facetsList = SearchConfig.facetsList;
        }
        if (!ctrl.rsnList) {
            ctrl.rsnList = SearchConfig.rsnList;
        }
        if (!ctrl.sortKeysList) {
            ctrl.sortKeysList = SearchConfig.sortKeysList;
        }
        if (!ctrl.hitsList) {
            ctrl.hitsList = SearchConfig.hitsList;
        }

        ctrl.maxSize = SearchConfig.maxSize;

        ctrl.query = {};
        ctrl.query.schema = ctrl.schemasList[0];
        ctrl.query.refine = null;
        ctrl.query.hits = ctrl.hitsList[2];
        ctrl.query.sortby = ctrl.sortKeysList[0];
        ctrl.query.current = 1;

        docid_enc = '"' + ctrl.docid.replace(/\\/g, '\\\\') + '"';
        if (ctrl.type === 'B') {
            ctrl.query.cql = 'cuba.authorityAuthorCode=' + docid_enc;
        } else if (ctrl.type === 'P') {
            ctrl.query.cql = 'cuba.authoritySubjectHeadingCode=' + docid_enc;
        } else if (ctrl.type === 'L') {
            ctrl.query.cql = 'cuba.authoritySubjectHeadingCode=' + docid_enc;
        } else if (ctrl.type === 'S') {
            ctrl.query.cql = 'cuba.controlNumberLinking=' + docid_enc;
        } else if (ctrl.type === 'E') {
            ctrl.query.cql = 'cuba.project_tpu_987m=' + docid_enc;
        } else {
            ctrl.query.cql = 'cql.serverChoice=' + docid_enc;
        }

        ctrl.response = undefined;
        ctrl.error = undefined;
        ctrl.selectedFacet = undefined;
        ctrl.selectedFacetItem = undefined;

        ctrl.callSearch();
    };

    ctrl.callSearch = function() {
        ctrl.loading = true;
        search(ctrl.catalogid, ctrl.query, function(err, response) {
            ctrl.loading = false;
            if (err) {
                ctrl.error = err.message || err;
            }
            ctrl.response = response;
        });
    };


    ctrl.pageChanged = function() {
        ctrl.callSearch();
    };

    ctrl.firstPage = function() {
        ctrl.query.current = 1;
        ctrl.callSearch();
    };

    ctrl.callRefineSearch = function(item) {
        console.log('callRefineSearch():', item);
        if (ctrl.query.refine) {
            ctrl.query.refine += ' and ' + item.facetspec.index + '="' + item.DATA + '"';
        } else {
            ctrl.query.refine = item.facetspec.index + '="' + item.DATA + '"';
        }
        console.log('refine.query is', ctrl.query.refine);
        ctrl.query.current = 1;
        ctrl.callSearch();
    };
    ctrl.callRefineSearchRSN = function(item) {
        console.log('callRefineSearchRSN():', item);
        if (ctrl.query.refine) {
            ctrl.query.refine += ' and ' + item.rsnspec.index + '="' + item.term + '"';
        } else {
            ctrl.query.refine = item.rsnspec.index + '="' + item.term + '"';
        }
        console.log('refine.query is', ctrl.query.refine);
        ctrl.query.current = 1;
        ctrl.callSearch();
    };

    ////////

    function search(catalogid, q, done) {
        var params = {};
        params.id = catalogid;
        params.operation = 'search';
        params.query = q.cql;
        params.startRecord = (q.current-1)*q.hits.value+1
        params.maximumRecords = q.hits.value;
        params.recordSchema = q.schema.value;
        params.sortKeys = q.sortby.value;

        if (q.refine) {
            params.query += ' and ( ' + q.refine + ' )';
        }

        ZebraService.get(params).$promise.then(function(response) {

            ctrl.query.cql = params.query; // Use by component rsn() 

            done(null, response);
        }, function(err) {
            done(err, null);
        });
    }

}
AdHocSearchController.$inject = ['SearchConfig', 'ZebraService'];
